@for (toast of toasts(); track toast) {
	<ngb-toast
		[header]="toast.header"
		[autohide]="toast.autohide"
		[delay]="toast.delay || defaultDelay"
		(hidden)="removeToast(toast)"
		[class]="toast.classname"
		>{{ toast.body }}
	</ngb-toast>
}
